import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../components/Common/PageTemplate';
import './ResearchLabs.css';

const ResearchLabs = () => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  const [activeTab, setActiveTab] = useState('biyoloji');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredLabs, setFilteredLabs] = useState([]);

  const biologyLabs = [
    {
      id: 272,
      name_tr: "Ali Celal Hoş İhtiyoloji Laboratuvarı",
      name_en: "Ali Celal Hoş Ichthyology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/ali_celal_hos_ihtiyoloji_laboratuvari-272",
      category_tr: "İhtiyoloji",
      category_en: "Ichthyology"
    },
    {
      id: 274,
      name_tr: "Arkeobotanik Laboratuvarı",
      name_en: "Archaeobotany Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab274/Arkeobotanik%20Lab_1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/arkeobotanik_laboratuvari-274",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 275,
      name_tr: "Bitki Doku Kültürü Laboratuvarı",
      name_en: "Plant Tissue Culture Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab275/IMG20220617095234.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_doku_kulturu_laboratuvari-275",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 276,
      name_tr: "Bitki Evrimi Araştırmaları Laboratuvarı (PERLab)",
      name_en: "Plant Evolution Research Laboratory (PERLab)",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab276/lab.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_evrimi_arastirmalari_laboratuvari_perlab-276",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 283,
      name_tr: "Bitki Fizyolojisi Araştırma Laboratuvarları",
      name_en: "Plant Physiology Research Laboratories",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab283/2020-5.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_fizyolojisi_arastirma_laboratuvarlari-283",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 38,
      name_tr: "Bitki Moleküler Biyolojisi ve Bitki Biyoteknolojisi Araştırma Laboratuvarları (BMBL)",
      name_en: "Plant Molecular Biology and Plant Biotechnology Research Laboratories (BMBL)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bitfiz1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_molekuler_biyolojisi_ve_bitki_biyoteknolojisi_arastirma_laboratuvarlari_bm-38",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 277,
      name_tr: "Bitki Sitogenetiği Laboratuvarı",
      name_en: "Plant Cytogenetics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab277/sitogenetik%20lab%20resim%201.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/bitki_sitogenetigi_laboratuvari-277",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 39,
      name_tr: "Biyocoğrafya Araştırma Laboratuvarı",
      name_en: "Biogeography Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyocografya1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyocografya_arastirma_laboratuvari-39",
      category_tr: "Biyocoğrafya",
      category_en: "Biogeography"
    },
    {
      id: 40,
      name_tr: "Biyofizik Laboratuvarı",
      name_en: "Biophysics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyofiziklaboratuvari.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyofizik_laboratuvari-40",
      category_tr: "Biyofizik",
      category_en: "Biophysics"
    },
    {
      id: 289,
      name_tr: "Biyoinformatik Laboratuvarı",
      name_en: "Bioinformatics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab289/bif_1IMG_20220923_165956.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyoinformatik_laboratuvari-289",
      category_tr: "Biyoinformatik",
      category_en: "Bioinformatics"
    },
    {
      id: 286,
      name_tr: "Biyokimya Laboratuvarı",
      name_en: "Biochemistry Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab286/untitled%20folder/WhatsApp%20Image%202022-09-12%20at%2014.52.00.jpeg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyokimya_laboratuvari-286",
      category_tr: "Biyokimya",
      category_en: "Biochemistry"
    },
    {
      id: 41,
      name_tr: "Biyokriminal (Adli) Entomoloji Laboratuvarı",
      name_en: "Biocriminal (Forensic) Entomology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyokriminal1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyokriminal_adli_entomoloji_laboratuvari-41",
      category_tr: "Entomoloji",
      category_en: "Entomology"
    },
    {
      id: 278,
      name_tr: "Biyolojik İzleme Laboratuvarı",
      name_en: "Biomonitoring Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab278/karadeniz%202008%20432.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyolojik_izleme_laboratuvari-278",
      category_tr: "Ekoloji",
      category_en: "Ecology"
    },
    {
      id: 42,
      name_tr: "Çevre Biyoteknolojisi Laboratuvarı",
      name_en: "Environmental Biotechnology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/cevrebiyoteknolojisi1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/cevre_biyoteknolojisi_laboratuvari-42",
      category_tr: "Biyoteknoloji",
      category_en: "Biotechnology"
    },
    {
      id: 43,
      name_tr: "Entomoloji Laboratuvarı",
      name_en: "Entomology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/entomoloji.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/entomoloji_laboratuvari-43",
      category_tr: "Entomoloji",
      category_en: "Entomology"
    },
    {
      id: 44,
      name_tr: "Epitel Hücre Araştırma Grubu (ECRG)",
      name_en: "Epithelial Cell Research Group (ECRG)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/epitelhucrearastirma1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/epitel_hucre_arastirma_grubu_ecrg-44",
      category_tr: "Hücre Biyolojisi",
      category_en: "Cell Biology"
    },
    {
      id: 45,
      name_tr: "Evrimsel Ekoloji Araştırma Laboratuvarları",
      name_en: "Evolutionary Ecology Research Laboratories",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/evrimselekoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/evrimsel_ekoloji_arastirma_laboratuvarlari-45",
      category_tr: "Ekoloji",
      category_en: "Ecology"
    },
    {
      id: 287,
      name_tr: "Evrimsel Mikrobiyal Genomik Laboratuvarı (EvoGen)",
      name_en: "Evolutionary Microbial Genomics Laboratory (EvoGen)",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab287/ScreenShot.png",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/evrimsel_mikrobiyal genomik_laboratuvari_evogen-287",
      category_tr: "Genomik",
      category_en: "Genomics"
    },
    {
      id: 46,
      name_tr: "Fonksiyonel Ekoloji Laboratuvarı (FEL)",
      name_en: "Functional Ecology Laboratory (FEL)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/fonksiyonelekoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/fonksiyonel_ekoloji_laboratuvari_fel-46",
      category_tr: "Ekoloji",
      category_en: "Ecology"
    },
    {
      id: 292,
      name_tr: "Fonksiyonel ve Evrimsel Genetik Laboratuvarı",
      name_en: "Functional and Evolutionary Genetics Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/fonksiyonel_ve_evrimsel_genetik_laboratuvari-292",
      category_tr: "Genetik",
      category_en: "Genetics"
    },
    {
      id: 47,
      name_tr: "Genetik Varyasyon ve Adaptasyon Laboratuvarı (GenVA Lab)",
      name_en: "Genetic Variation and Adaptation Laboratory (GenVA Lab)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/genvalab1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/genetik_varyasyon_ve_adaptasyon_laboratuvari_genva_lab-47",
      category_tr: "Genetik",
      category_en: "Genetics"
    },
    {
      id: 49,
      name_tr: "Hücre Biyolojisi Laboratuvarı",
      name_en: "Cell Biology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/hucrebiyolojisi1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/hucre_biyolojisi_laboratuvari_-49",
      category_tr: "Hücre Biyolojisi",
      category_en: "Cell Biology"
    },
    {
      id: 50,
      name_tr: "Hücre Fizyolojisi Laboratuvarı",
      name_en: "Cell Physiology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/hucrefizyolojisi1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/hucre_fizyolojisi_laboratuvari-50",
      category_tr: "Hücre Biyolojisi",
      category_en: "Cell Biology"
    },
    {
      id: 51,
      name_tr: "Hücre Kültürü Laboratuvarı",
      name_en: "Cell Culture Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/hucrekulturu1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/hucre_kulturu_laboratuvari_-51",
      category_tr: "Hücre Biyolojisi",
      category_en: "Cell Biology"
    },
    {
      id: 52,
      name_tr: "Kene Araştırmaları Laboratuvarı",
      name_en: "Tick Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/kene_arastirmalari_laboratuvari-52",
      category_tr: "Entomoloji",
      category_en: "Entomology"
    },
    {
      id: 53,
      name_tr: "Moleküler Biyoloji Hücre Kültürü Laboratuvarı",
      name_en: "Molecular Biology Cell Culture Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/molekulerbiyolojihucrekulturu1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/moleküler_biyoloji_hücre_kültürü_laboratuvari-53",
      category_tr: "Moleküler Biyoloji",
      category_en: "Molecular Biology"
    },
    {
      id: 54,
      name_tr: "Moleküler Bitki Sistematiği Laboratuvarı (MOBİS)",
      name_en: "Molecular Plant Systematics Laboratory (MOBİS)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bitkilab1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_bitki_sistematigi_laboratuvari_mobis_-54",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 288,
      name_tr: "Moleküler Hücre Biyolojisi Laboratuvarı",
      name_en: "Molecular Cell Biology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_hucre_biyolojisi_laboratuvari-288",
      category_tr: "Moleküler Biyoloji",
      category_en: "Molecular Biology"
    },
    {
      id: 55,
      name_tr: "Moleküler Mikrobiyoloji Laboratuvarı",
      name_en: "Molecular Microbiology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/molekulermikrobiyoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_mikrobiyoloji_laboratuvari-55",
      category_tr: "Mikrobiyoloji",
      category_en: "Microbiology"
    },
    {
      id: 279,
      name_tr: "Moleküler Sistematik Entomoloji Laboratuvarı (MOSEL)",
      name_en: "Molecular Systematic Entomology Laboratory (MOSEL)",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab279/MOSEL%20-%20Kopya.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/molekuler_sistematik_entomoloji_laboratuvari_mosel-279",
      category_tr: "Entomoloji",
      category_en: "Entomology"
    },
    {
      id: 56,
      name_tr: "Nadir Hastalıkların Moleküler Patolojisi Araştırma Grubu",
      name_en: "Molecular Pathology of Rare Diseases Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/molekulerbiyolojidna1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/nadir_hastaliklarin_molekuler_patolojisi_arastirma_grubu-56",
      category_tr: "Patoloji",
      category_en: "Pathology"
    },
    {
      id: 57,
      name_tr: "Palinoloji Laboratuvarı",
      name_en: "Palynology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/palinoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/palinoloji_laboratuvari-57",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 37,
      name_tr: "Palinoloji ve Arı Ürünleri Analiz Laboratuvarı",
      name_en: "Palynology and Bee Products Analysis Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab37/palinoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/palinoloji_ve_ari_urunleri_analiz_laboratuvari-37",
      category_tr: "Botanik",
      category_en: "Botany"
    },
    {
      id: 294,
      name_tr: "PAXIS Lab Araştırma Grubu",
      name_en: "PAXIS Lab Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab294/paxis1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/paxis_lab_arastirma_grubu-294",
      category_tr: "Araştırma",
      category_en: "Research"
    },
    {
      id: 281,
      name_tr: "Protozooloji Laboratuvarı",
      name_en: "Protozoology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/protozooloji_laboratuvari-281",
      category_tr: "Mikrobiyoloji",
      category_en: "Microbiology"
    },
    {
      id: 280,
      name_tr: "Su Kimyası Laboratuvarı",
      name_en: "Water Chemistry Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/su_kimyasi_laboratuvari-280",
      category_tr: "Kimya",
      category_en: "Chemistry"
    },
    {
      id: 58,
      name_tr: "Sucul Yaşam Laboratuvarı",
      name_en: "Aquatic Life Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/sucul_yasam_laboratuvari-58",
      category_tr: "Ekoloji",
      category_en: "Ecology"
    },
    {
      id: 273,
      name_tr: "Tatlı Su Balıkları Biyolojisi ve Ekolojisi Laboratuvarı (TABBEL)",
      name_en: "Freshwater Fish Biology and Ecology Laboratory (TABBEL)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/bos.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/tatli_su_baliklari_biyolojisi_ve_ekolojisi_laboratuvari_tabbel-273",
      category_tr: "İhtiyoloji",
      category_en: "Ichthyology"
    },
    {
      id: 48,
      name_tr: "Tıbbi ve Endüstriyel Biyoteknoloji Laboratuvarı",
      name_en: "Medical and Industrial Biotechnology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/tibbiveendustriyelbiyoteknoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/tibbi_ve_endustriyel_biyoteknoloji_laboratuvari_-48",
      category_tr: "Biyoteknoloji",
      category_en: "Biotechnology"
    },
    {
      id: 59,
      name_tr: "Toksikoloji Laboratuvarı",
      name_en: "Toxicology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/toksikoloji1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/toksikoloji_laboratuvari-59",
      category_tr: "Toksikoloji",
      category_en: "Toxicology"
    },
    {
      id: 60,
      name_tr: "Uygulamalı Entomoloji Laboratuvarı",
      name_en: "Applied Entomology Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_labs_/lab60/LOGO.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/uygulamali_entomoloji_laboratuvari-60",
      category_tr: "Entomoloji",
      category_en: "Entomology"
    },
    {
      id: 61,
      name_tr: "Vektör Ekolojisi Araştırma Grubu Laboratuvarı (VERG)",
      name_en: "Vector Ecology Research Group Laboratory (VERG)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/verg1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/vector_ecology_research_group_laboratory_verg-61",
      category_tr: "Ekoloji",
      category_en: "Ecology"
    }
  ];

  const chemistryLabs = [
    {
      id: 62,
      name_tr: "Anorganik Kimya Araştırma Laboratuvarı I",
      name_en: "Inorganic Chemistry Research Laboratory I",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/orgkim3.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/anorganik_kimya_arastirma_laboratuvari_i_-62",
      category_tr: "Anorganik Kimya",
      category_en: "Inorganic Chemistry"
    },
    {
      id: 63,
      name_tr: "Anorganik Kimya Araştırma Laboratuvarı II",
      name_en: "Inorganic Chemistry Research Laboratory II",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/orgkim1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/anorganik_kimya_arastirma_laboratuvari_ii-63",
      category_tr: "Anorganik Kimya",
      category_en: "Inorganic Chemistry"
    },
    {
      id: 64,
      name_tr: "Anorganik Kimya Araştırma Laboratuvarı III",
      name_en: "Inorganic Chemistry Research Laboratory III",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/anorganikkimyalab3-1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/anorganik_kimya_arastirma_laboratuvari_iii-64",
      category_tr: "Anorganik Kimya",
      category_en: "Inorganic Chemistry"
    },
    {
      id: 66,
      name_tr: "Biosmart",
      name_en: "Biosmart",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biosmart2.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biosmart-66",
      category_tr: "Biyokimya",
      category_en: "Biochemistry"
    },
    {
      id: 68,
      name_tr: "Biyokromatografi ve Biyodiyagnostik Araştırma Grubu",
      name_en: "Biochromatography and Biodiagnostic Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/adildenizli1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/biyokromatografi_ve_biyodiyagnostik_arastirma_grubu-68",
      category_tr: "Biyokimya",
      category_en: "Biochemistry"
    },
    {
      id: 69,
      name_tr: "Elektrokimya Elektroanaliz Elektrokataliz Araştırma Laboratuvarı",
      name_en: "Electrochemistry Electroanalysis Electrocatalysis Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/elekrokimyaelektroanalizelektroktaliz1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/elektrokimya_elektroanaliz_elektrokataliz_arastirma_laboratuvari_-69",
      category_tr: "Elektrokimya",
      category_en: "Electrochemistry"
    },
    {
      id: 70,
      name_tr: "Elektrokimya-Elektroaktif Polimerler ve Korozyon Araştırma Laboratuvarı",
      name_en: "Electrochemistry-Electroactive Polymers and Corrosion Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/elektrokimyaelek.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/elektrokimyaelektroaktif_polimerler_ve_korozyon_arastirma_laboratuvari_-70",
      category_tr: "Elektrokimya",
      category_en: "Electrochemistry"
    },
    {
      id: 71,
      name_tr: "Elektrokimyasal Arayüzeyler ve Biyomalzemeler Araştırma Grubu",
      name_en: "Electrochemical Interfaces and Biomaterials Research Group",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/elektrokimyasalarayuzler1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/elektrokimyasal_arayuzeyler_ve_biyomalzemeler_arastirma_grubu-71",
      category_tr: "Elektrokimya",
      category_en: "Electrochemistry"
    },
    {
      id: 72,
      name_tr: "Kütle Spektrometrisi Araştırma Laboratuvarı (SAREG)",
      name_en: "Mass Spectrometry Research Laboratory (SAREG)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/kutle2.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/kutle_spektrometrisi_arastirma_laboratuvari_sareg-72",
      category_tr: "Analitik Kimya",
      category_en: "Analytical Chemistry"
    },
    {
      id: 73,
      name_tr: "Olefin Metatez Laboratuvarı",
      name_en: "Olefin Metathesis Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/olefin1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/olefin_metatez_laboratuvari-73",
      category_tr: "Organik Kimya",
      category_en: "Organic Chemistry"
    },
    {
      id: 74,
      name_tr: "Organik Kimya Araştırma Laboratuvarı II (ORGSEN)",
      name_en: "Organic Chemistry Research Laboratory II (ORGSEN)",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/organikkimya1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/organik_kimya_arastirma_laboratuvari_ii_orgsen-74",
      category_tr: "Organik Kimya",
      category_en: "Organic Chemistry"
    },
    {
      id: 67,
      name_tr: "Sentetik Biyofiziksel Sistemler Laboratuvarı",
      name_en: "Synthetic Biophysical Systems Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/biyofizkim1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/sentetik_biyofiziksel_sistemler_laboratuvari-67",
      category_tr: "Fizikokimya",
      category_en: "Physical Chemistry"
    },
    {
      id: 75,
      name_tr: "Teorik Kimya Araştırma Laboratuvarı",
      name_en: "Theoretical Chemistry Research Laboratory",
      image: "https://lab.hacettepe.edu.tr/fs_/labs/teorikkimya1.jpg",
      link: "https://lab.hacettepe.edu.tr/tr/laboratuvar/teorik_kimya_arastirma_laboratuvari_-75",
      category_tr: "Teorik Kimya",
      category_en: "Theoretical Chemistry"
    }
  ];

  const getLabName = (lab) => isEn ? lab.name_en : lab.name_tr;
  const getLabCategory = (lab) => isEn ? lab.category_en : lab.category_tr;

  useEffect(() => {
    const labs = activeTab === 'biyoloji' ? biologyLabs : chemistryLabs;
    let filtered = labs;

    // Arama filtresi
    if (searchTerm) {
      filtered = filtered.filter(lab =>
        getLabName(lab).toLowerCase().includes(searchTerm.toLowerCase()) ||
        getLabCategory(lab).toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredLabs(filtered);
  }, [activeTab, searchTerm, isEn]);

  // Tab değiştiğinde kategori seçimini sıfırla
  useEffect(() => {
    setSearchTerm('');
  }, [activeTab]);

  const currentLabs = activeTab === 'biyoloji' ? biologyLabs : chemistryLabs;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
    <div className="research-labs-page">
      {/* Video Header */}
      <div className="video-header-container">
        <video
          className="video-header"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/fenfakultesivideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay">
          <div className="video-content">
            <motion.h1
              className="video-title"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              {t('pages.researchLabs.pageTitle')}
            </motion.h1>
            <motion.p
              className="video-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.8 }}
            >
              {t('pages.researchLabs.pageSubtitle')}
            </motion.p>
          </div>
        </div>
      </div>

      {/* Labs Content Section */}
      <div className="research-labs-container">
        <motion.div
          className="labs-hero"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="gradient-text">{t('pages.researchLabs.pageTitle')}</span>
            </h1>
            <p className="hero-subtitle">
              {t('pages.researchLabs.heroDescription')}
            </p>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">{biologyLabs.length + chemistryLabs.length}+</span>
                <span className="stat-label">{t('pages.researchLabs.activeLabs')}</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">{[...new Set([...biologyLabs.map(lab => lab.category_en), ...chemistryLabs.map(lab => lab.category_en)])].length}</span>
                <span className="stat-label">{t('pages.researchLabs.researchFields')}</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">150+</span>
                <span className="stat-label">{t('pages.researchLabs.researchers')}</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="dna-helix"></div>
            <div className="molecules">
              <div className="molecule"></div>
              <div className="molecule"></div>
              <div className="molecule"></div>
              <div className="molecule"></div>
              <div className="molecule"></div>
            </div>
          </div>
        </motion.div>

      </div>

      {/* Content Section with Container */}
      <div className="labs-content-container">
        {/* Controls Section */}
        <motion.div
          className="labs-controls"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <div className="tab-buttons">
            <button
              className={`tab-button ${activeTab === 'biyoloji' ? 'active' : ''}`}
              onClick={() => setActiveTab('biyoloji')}
            >
              <span className="tab-icon">🧬</span>
              {t('pages.researchLabs.biologyDept')}
              <span className="tab-count">{biologyLabs.length}</span>
            </button>
            <button
              className={`tab-button ${activeTab === 'kimya' ? 'active' : ''}`}
              onClick={() => setActiveTab('kimya')}
            >
              <span className="tab-icon">⚗️</span>
              {t('pages.researchLabs.chemistryDept')}
              <span className="tab-count">{chemistryLabs.length}</span>
            </button>
          </div>

          <div className="search-container">
            <input
              type="text"
              placeholder={t('pages.researchLabs.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <div className="search-icon">🔍</div>
          </div>
        </motion.div>

        {/* Labs Grid */}
        <motion.div
          className="labs-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {filteredLabs.map((lab, index) => (
            <motion.div
              key={lab.id}
              className="lab-card"
              variants={itemVariants}
              whileHover={{
                y: -10,
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)"
              }}
              whileTap={{ scale: 0.98 }}
            >
              <div
                className="lab-image-container clickable"
                onClick={() => window.open(lab.link, '_blank')}
              >
                <img
                  src={lab.image}
                  alt={getLabName(lab)}
                  className="lab-image"
                  onError={(e) => {
                    e.target.src = '/fenfakultesilogo.png';
                  }}
                />
                <div className="lab-overlay">
                  <span className="lab-category">{getLabCategory(lab)}</span>
                  <div className="lab-id">#{lab.id}</div>
                  <div className="click-hint">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              <div className="lab-content">
                <h3 className="lab-title">{getLabName(lab)}</h3>
                <div className="lab-footer">
                  <span className="lab-faculty">{t('pages.researchLabs.facultyOfScience')}</span>
                  <a
                    href={lab.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lab-link"
                  >
                    <span>{t('pages.researchLabs.details')}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>

              <div className="lab-glow"></div>
            </motion.div>
          ))}
        </motion.div>

        {filteredLabs.length === 0 && searchTerm && (
          <motion.div
            className="no-results"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <div className="no-results-icon">🔬</div>
            <h3>{t('pages.researchLabs.noLabFound')}</h3>
            <p>{t('pages.researchLabs.noResults', { searchTerm })}</p>
          </motion.div>
        )}

        {/* Research Impact Section */}
        <motion.div
          className="research-impact"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>{t('pages.researchLabs.researchImpact')}</h2>
          <div className="impact-grid">
            <div className="impact-item">
              <div className="impact-icon">📊</div>
              <h4>{t('pages.researchLabs.publications')}</h4>
              <p>{t('pages.researchLabs.publicationsDesc')}</p>
            </div>
            <div className="impact-item">
              <div className="impact-icon">🏆</div>
              <h4>{t('pages.researchLabs.awards')}</h4>
              <p>{t('pages.researchLabs.awardsDesc')}</p>
            </div>
            <div className="impact-item">
              <div className="impact-icon">🤝</div>
              <h4>{t('pages.researchLabs.collaborations')}</h4>
              <p>{t('pages.researchLabs.collaborationsDesc')}</p>
            </div>
            <div className="impact-item">
              <div className="impact-icon">💡</div>
              <h4>{t('pages.researchLabs.innovation')}</h4>
              <p>{t('pages.researchLabs.innovationDesc')}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ResearchLabs;
